import { render, staticRenderFns } from "./societeFactures.vue?vue&type=template&id=47656219&scoped=true&"
import script from "./societeFactures.vue?vue&type=script&lang=js&"
export * from "./societeFactures.vue?vue&type=script&lang=js&"
import style0 from "./societeFactures.vue?vue&type=style&index=0&id=47656219&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47656219",
  null
  
)

export default component.exports